import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrows-left-right-outward-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor" },
        React.createElement("path", { d: "M14 8.5H3" }),
        React.createElement("path", { fill: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m12.5 10.25 2-1.75-2-1.75zm-8 0-2-1.75 2-1.75z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
